<template>
<!-- 과정항목 관리 팝업 -->
<div class="modal fade" id="option" tabindex="-1" role="dialog" aria-labelledby="commentLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered w-300px" role="document">
        <div class="modal-content">
            <a type="button" class="close" @click="$emit('close')" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">
                    <img src="../../../assets/img/close.png" alt="close" class="pointer close-btn">
                </span>
            </a>
            <div class="modal-body">
                <div>
                    <h3 class="font-14 bold">옵션 입력</h3>
                    <div class="mt-10 mb-10">
                        <button type="button" class="admin-btn-default" @click="addOptions()">옵션추가</button>
                        <button type="button" class="admin-btn-default ml-05" @click="delOptions()" :disabled="options.length < 3">옵션삭제</button>
                    </div>
                    <div v-for="(item, index) of options" :key="index" class="mt-05">
                        <input type="text" class="w-100per" v-model="item.content" />
                    </div>
                </div>
            </div>
            <div class="modal-footer txt-center">
                <a class="admin-btn-default btn pointer" @click="exportData('^')" data-dismiss="modal" aria-label="Close">입력 완료(선택)</a>
              <a class="admin-btn-default btn pointer" @click="exportData('&')" data-dismiss="modal" aria-label="Close">입력 완료(중복)</a>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: ['modalIndex', 'parentOption'],
    data: () => ({
        options: [
            {
                content: ''
            },
            {
                content: ''
            }
        ]
    }),
    mounted () {
        if (this.parentOption !== 'direct' && this.parentOption !== '') {
          var splitOptions='';

             if(this.parentOption.indexOf('^') !== -1 )
            splitOptions= this.parentOption.split('^')
          
            if(this.parentOption.indexOf('&') !== -1 )
              splitOptions= this.parentOption.split('&')


            var options = []
            for (var item of splitOptions) {
                options.push({
                    content: item
                })
            }
            this.options = options
        }
    },
    
    beforeDestroy () {
    },

    methods: {
        exportData (tag) {
            var options = []
            for (var item of this.options) {
                if (item.content.trim() !== '') {
                    options.push(item.content)
                }
            }

            options = options.join(tag)
            this.$emit('save', options, this.modalIndex)
        },
        
        addOptions () {
            if (this.options.length === 30) {
                alert('옵션은 최대 30개 까지만 추가 가능합니다.')
                return false
            }
            this.options.push( {
                content: ''
            })
        },

        delOptions () {
            var length = this.options.length
            this.options.splice(length - 1, 1)
        }
    }
}
</script>
    